import { render, staticRenderFns } from "./Alarm.vue?vue&type=template&id=41a484c2&scoped=true"
import script from "./Alarm.vue?vue&type=script&lang=js"
export * from "./Alarm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a484c2",
  null
  
)

export default component.exports